/* eslint-disable max-len */
import React, { useCallback, useState } from 'react';
import GroupSettingCard from './group';
import TeamsSettingCard from './team';
import PrioritySettingCard from './priorities';
import LabelsSettingCard from './labels';
import { DropResult } from 'react-beautiful-dnd';
import ModalCustom from '../models/modal';
import InviteTeamsModal from '../models/inviteTeamsModal';
import DeleteModal from '../models/deleteModel';
import Labelmodal from '../models/labelmodal';
import { useDispatch, useSelector } from 'react-redux';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import { deleteTaskGroup, updateGroupDetail } from '../../services/taskServices';
import { captureException } from '../../services/logService';
import { removeInvitedMember } from '../../services/projectServices';
import StatusSettingCard from './status/status';
import AddStatusModal from '../models/addStatusmodal';
import GithubSettingCard from './githubRepository';
import SettingCard from './settingCard';
import { rootStore } from '../../mobx/rootStore';
import { ProjectModel } from '../../mobx/models/project';
import { WorkspaceModel } from '../../mobx/models/workspace';
import { UserModel } from '../../mobx/models/user';
import { Label, RawTaskGroup } from '../../mobx/interfaces/project';
import { observer } from 'mobx-react-lite';
import InviteMemberModal from '../models/inviteMemberModal/inviteMemberModal';
import CreateGroupModal from '../models/createGroupModal';
import { TaskGroupInterface } from '../../interfaces/TaskInterface';
import { StatusListInterface } from '../../interfaces/ProjectInterface';
import SuccessfulModel from '../models/successfulModel';
import VercelSettingCard from './vercelIntergration';
import { RootReducerInterface } from '../../interfaces/RootReducerInterface';
// eslint-disable-next-line @typescript-eslint/no-redeclare
declare type DropResult = typeof import('react-beautiful-dnd');

interface Props {
  currentProject: ProjectModel;
  themeMode: { theme: string };
  onUpdateMileStone: (value: boolean) => void;
  onUpdateEstimate: (value: boolean) => void;
  onUpdateMultiAssignee?: (value: boolean) => void;
  onUpdateStatus: (value: boolean) => void;
  onUpdatePriority: (value: boolean) => void;
  onUpdateLabels: (value: boolean) => void;
  onUpdateGroup: (value: boolean) => void;
  taskGroups: TaskGroupInterface[];
  loading: boolean;
  customersUsers: UserModel[];
  paramsId?: string;
  deleteLabel?: (id: string) => void;
  isTemplateProject?: boolean;
  loadData: () => void;
  setLoading: (value: boolean) => void;
  workspaceDetails: WorkspaceModel;
  loadingButton: {
    group: boolean;
    status: boolean;
    priority: boolean;
    label: boolean;
    multiAssignee: boolean;
    estimation: boolean;
    milestone: boolean;
  };
}

const SettingCards: React.FC<Props> = (props) => {
  const {
    currentProject,
    themeMode,
    onUpdateMileStone,
    onUpdateEstimate,
    onUpdateMultiAssignee,
    onUpdatePriority,
    onUpdateLabels,
    taskGroups,
    loading,
    customersUsers,
    paramsId,
    deleteLabel,
    isTemplateProject = false,
    loadData,
    setLoading,
    workspaceDetails,
    onUpdateStatus,
    onUpdateGroup,
    loadingButton
  } = props;
  //States
  const [ModalOpen, setModalOpen] = useState(false);
  const [isMainModel, setMainModel] = useState(false);
  const [isSubModel, setSubModel] = useState(false);
  const [isDeleteMemberModel, setIsDeleteMemberModel] = useState(false);
  const [isMemberId, setIsMemberId] = useState('');
  const [isDeletelabelModel, setIsDeleteLabelModel] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [labelId, setLabelId] = useState('');
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [statusType, setStatusType] = useState(0);
  //Set edit data for model
  const [groupData, setGroupData] = useState<TaskGroupInterface | null>(null);
  const [statusData, setStatusData] = useState<StatusListInterface | null>(null);
  const [labelData, setLabelData] = useState<Label | null>(null);
  const [isSuccessfulModalOpen, setIsSuccessfulModalOpen] = useState(false);
  const [clientLoginUrl, setClientLoginUrl] = useState('');
  // Reducer state variables
  const settingsSelector = useSelector((state: RootReducerInterface) => state.settings);
  const { settingIntegration } = settingsSelector;
  //Mobx store variables
  const { workspaceStore } = rootStore;
  const { currentWorkspace: workspace } = workspaceStore;

  //Other variable
  const dispatch = useDispatch();

  const handleOnclickOpenModel = () => {
    setIsSuccessfulModalOpen(true);
  };

  const handleOnclickCloseModel = () => {
    setIsSuccessfulModalOpen(false);
  };

  const onClickDeleteLabel = useCallback(
    (labelId: string) => {
      if (deleteLabel) deleteLabel(labelId);
      setIsDeleteLabelModel(false);
    },
    [deleteLabel]
  );

  const onCloseGroupModal = useCallback(() => {
    setGroupData(null);
    setModalOpen(false);
  }, []);

  const onClickEditGroup = useCallback((group: any) => {
    setGroupData(group);
    setModalOpen(true);
  }, []);

  const onClickEditLabel = useCallback((item: Label) => {
    setLabelData(item);
    setIsOpen(true);
  }, []);

  const onCreateNewLabel = () => {
    setIsOpen(true);
  };

  const onCloseNewLabel = () => {
    setLabelData(null);
    setIsOpen(false);
  };

  const OpenDeleteMemberModel = (id: string) => {
    setIsDeleteMemberModel(true);
    setIsMemberId(id);
  };

  const onCloseDeleteMemberModel = () => {
    setIsDeleteMemberModel(false);
  };

  const onSubModel = () => {
    setMainModel(false);
    setSubModel(true);
  };

  const onCloseSubModal = (clientUrl?: string) => {
    setSubModel(false);
    if (clientUrl) {
      setClientLoginUrl(clientUrl);
      handleOnclickOpenModel();
    }
  };

  const openDeleteLabelModel = (id: string) => {
    setIsDeleteLabelModel(true);
    setLabelId(id);
  };

  const closeDeleteLabelModel = () => {
    setIsDeleteLabelModel(false);
  };

  const handleDragEnd = async (result: DropResult) => {
    if (!result.destination) return;
    const updatedGroupNames = Array.from(taskGroups);
    const [removed] = updatedGroupNames.splice(result.source.index, 1);
    updatedGroupNames.splice(result.destination.index, 0, removed);
    const updatedTaskGroups: RawTaskGroup[] = updatedGroupNames?.map((item, index) => {
      return { ...(item || {}), index: index };
    });
    rootStore.projectStore.currentProject?.setTaskGroups(updatedTaskGroups);
    const updatePromises = updatedTaskGroups?.map((item) => {
      const { id, index } = item;
      const payload = { itemId: id, index: index };
      return dispatch(updateGroupDetail(payload, true));
    });
    try {
      await Promise.all(updatePromises);
    } catch (error) {
      captureException(error);
      console.error('error', error);
    }
    // }
  };

  const closeInviteModal = () => {
    setMainModel(false);
  };

  const onClickDeleteMember = useCallback(
    async (memberId: string) => {
      try {
        setLoading(true);
        const userDetails = UserPreferenceSingleton.getInstance().getCurrentUser();
        const result = await dispatch(removeInvitedMember(userDetails?.id, currentProject?.id, memberId));
        if (result) {
          loadData();
        }
      } catch (error) {
        captureException(error);
        console.log('error', error);
      } finally {
        setLoading(false);
      }
      setIsDeleteMemberModel(false);
    },
    [currentProject?.id, dispatch, loadData, setLoading]
  );

  const deleteGroup = useCallback(
    async (item: { id: string }) => {
      try {
        setLoading(true);
        const result = await dispatch(deleteTaskGroup(item?.id));
        if (result) {
          loadData();
        }
      } catch (error) {
        captureException(error);
        console.log('error', error);
      } finally {
        setLoading(false);
      }
    },
    [dispatch, loadData, setLoading]
  );

  const onCloseStatusModal = useCallback(() => {
    setIsStatusModalOpen(false);
    setStatusData(null);
  }, []);

  return (
    <>
      <TeamsSettingCard
        setMainModel={(value) => setMainModel(value)}
        OpenDeleteMemberModel={(id) => OpenDeleteMemberModel(id)}
      />
      <GroupSettingCard
        themeMode={themeMode}
        handleDragEnd={(result) => handleDragEnd(result)}
        taskGroups={taskGroups}
        onClickEditGroup={(group) => onClickEditGroup(group)}
        deleteGroup={(group) => deleteGroup(group)}
        loading={loading}
        setModalOpen={(value) => setModalOpen(value)}
        onUpdateGroup={(value) => onUpdateGroup(value)}
        loadingButton={loadingButton?.group}
      />
      <StatusSettingCard
        themeMode={themeMode}
        loadingButton={loadingButton?.status}
        setModalOpen={(value) => setIsStatusModalOpen(value)}
        onUpdateStatus={(value) => onUpdateStatus(value)}
        setStatusType={(value) => setStatusType(value)}
        isTemplateProject={isTemplateProject}
        setStatusData={setStatusData}
      />
      <PrioritySettingCard
        themeMode={themeMode}
        onUpdatePriority={(value) => onUpdatePriority(value)}
        loadingButton={loadingButton?.priority}
      />
      <LabelsSettingCard
        onUpdateLabels={(value) => onUpdateLabels(value)}
        openDeleteLabelModel={(id) => openDeleteLabelModel(id)}
        onClickEditLabel={(item) => onClickEditLabel(item)}
        handleclick={onCreateNewLabel}
        loadingButton={loadingButton?.label}
      />
      {/* multiassign or single assign */}
      <SettingCard
        onUpdateSetting={(value) => {
          if (onUpdateMultiAssignee) onUpdateMultiAssignee(value);
        }}
        loadingButton={loadingButton?.multiAssignee}
        title='Multiple assignee'
        subtitle='To enable this feature, you can allow tasks to be assigned to multiple members.'
      />
      {/* Estimation on and off */}
      <SettingCard
        onUpdateSetting={(value) => {
          if (onUpdateEstimate) onUpdateEstimate(value);
        }}
        loadingButton={loadingButton?.estimation}
        title='Estimation'
        subtitle='Estimates communicate task complexity and cycle capacity. Choose how to estimate with your team below.'
      />
      {/* Milestone on and off */}
      <SettingCard
        onUpdateSetting={(value) => {
          if (onUpdateMileStone) onUpdateMileStone(value);
        }}
        loadingButton={loadingButton?.milestone}
        title='Milestone'
        subtitle='Milestones communicate progress, validate accomplishments, and help track adherence to schedules and objectives.'
      />
      {/* Github repository card */}
      <GithubSettingCard />

      {/* Vercel intigration card */}
      {settingIntegration?.vercel_connected && <VercelSettingCard />}

      <ModalCustom open={isMainModel} onClose={closeInviteModal} width={400}>
        <InviteMemberModal
          workspace={workspaceDetails}
          currentProject={currentProject}
          customersUsers={customersUsers}
          onSubModel={onSubModel}
          setLoading={setLoading}
          onClose={closeInviteModal}
        />
      </ModalCustom>
      <ModalCustom open={ModalOpen} onClose={onCloseGroupModal} width={462}>
        <CreateGroupModal groupData={groupData} loadData={loadData} onClose={onCloseGroupModal} />
      </ModalCustom>
      <ModalCustom open={isStatusModalOpen} onClose={onCloseStatusModal} width={334}>
        <AddStatusModal
          onCancel={onCloseStatusModal}
          statusType={statusType}
          projectId={currentProject?.id}
          statusData={statusData}
          isTemplateProject={isTemplateProject}
        />
      </ModalCustom>
      <ModalCustom open={isSubModel} onClose={onCloseSubModal} width={400}>
        <InviteTeamsModal
          onCancel={onCloseSubModal}
          project_id={paramsId}
          isTextVisible={true}
          projectName={currentProject?.name}
          workspace_id={workspace?.id!}
        />
      </ModalCustom>
      <ModalCustom open={isSuccessfulModalOpen} onClose={handleOnclickCloseModel} width={420}>
        <SuccessfulModel clientLoginUrl={clientLoginUrl} onCancel={handleOnclickCloseModel} />
      </ModalCustom>
      <ModalCustom open={isDeleteMemberModel} onClose={onCloseDeleteMemberModel} width={334}>
        <DeleteModal
          onClose={onCloseDeleteMemberModel}
          loading={loading}
          buttonText='Remove'
          onOk={() => onClickDeleteMember(isMemberId)}
          modalTitle='Remove Member?'
          description='Are you sure you want to remove this member from the project?'
        />
      </ModalCustom>
      <ModalCustom open={isDeletelabelModel} onClose={closeDeleteLabelModel} width={334}>
        <DeleteModal
          onClose={closeDeleteLabelModel}
          loading={loading}
          onOk={() => onClickDeleteLabel(labelId)}
          modalTitle='Delete Label?'
          description='Are you sure you want to delete this label?'
        />
      </ModalCustom>
      <ModalCustom open={isOpen} onClose={onCloseNewLabel} width={462}>
        <Labelmodal isTemplateProject={isTemplateProject} onClose={onCloseNewLabel} labelData={labelData} />
      </ModalCustom>
    </>
  );
};

export default observer(SettingCards);
